import React, { useEffect, useState } from "react";
import '../Styles/Admin/Home.css';
import AdminHead from "./AdminHead";
import { useNavigate, useParams } from "react-router-dom";
import { collection, query, where, getDocs, getCountFromServer } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";

function Home() {
  const nav = useNavigate();
  const { UID } = useParams();

  const [sapakimCount, setSapakimCount] = useState(0);
  const [ordersCount, setOrdersCount] = useState(0);
  const [customersCount, setCustomersCount] = useState(0);
  const [quotationsCount, setQuotationsCount] = useState(0);
  const [catalogCount, setCatalogCount] = useState(0);
  const [ads, setAds] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const sapakimQuery = query(collection(db, "Users"), where("Role", "==", "Sapakim"));
        const sapakimSnapshot = await getDocs(sapakimQuery);
        setSapakimCount(sapakimSnapshot.size);

        const ordersSnapshot = await getDocs(collection(db, "Orders"));
        setOrdersCount(ordersSnapshot.size);

        const customersQuery = query(collection(db, "Customers"), where("SapakId", "==", UID));
        const customersSnapshot = await getDocs(customersQuery);
        setCustomersCount(customersSnapshot.size);

        const quotationsSnapshot = await getCountFromServer(collection(db, "Quotations"));
        setQuotationsCount(quotationsSnapshot.data().count);

        const catalogSnapshot = await getDocs(collection(db, "Catalog"));
        setCatalogCount(catalogSnapshot.size);

        const adsSnapshot = await getDocs(collection(db, "Ads"));
        setAds(adsSnapshot.size);

      } catch (error) {
        console.error("שגיאה בטעינת הנתונים:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [UID]);

  return (
    <React.Fragment>
      <AdminHead />
      {loading ? (
        <Loading />
      ) : (
        <div className="functions" dir="rtl">
          <div className="FBox">
            <h1>סוכנים</h1>
            <h2>{sapakimCount}</h2>
            <button onClick={() => nav(`/AdminHome/${UID}/ViewSapakim`)}>הצג הכל</button>
          </div>
          <div className="FBox">
            <h1>הזמנות</h1>
            <h2>{ordersCount}</h2>
            <button onClick={() => nav(`/AdminHome/${UID}/ViewAllOrders`)}>הצג הכל</button>
          </div>
          <div className="FBox">
            <h1>הצעות מחיר</h1>
            <h2>{quotationsCount}</h2>
            <button onClick={() => nav(`/AdminHome/${UID}/ViewQuotations`)}>הצג הכל</button>
          </div>
          <div className="FBox">
            <h1>קטלוג</h1>
            <h2>{catalogCount}</h2>
            <button onClick={() => nav(`/AdminHome/${UID}/Catalog`)}>הצג הכל</button>
          </div>
          <div className="FBox">
            <h1>פרסומת</h1>
            <h2>{ads}</h2>
            <button onClick={() => nav(`/AdminHome/${UID}/Ads`)}>הצג הכל</button>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default Home;
